import { useState } from "react";
import {
  LGoCard,
  LGoCardHeader,
  LGoCardTitle,
  LGoCardDescription,
  LGoCardContent,
} from "@/ui/branded";
import { PARTNER_TERMS_URL } from "@/domain/user/legal";
import { LoginForm } from "./components/LoginForm";
import { RegisterForm } from "./components/RegisterForm";
import { ForgotPasswordForm } from "./components/ForgotPasswordForm";

type AuthMode = "login" | "register" | "forgot-password";

const titles: Record<AuthMode, string> = {
  login: "Přihlášení",
  register: "Registrace",
  "forgot-password": "Obnova hesla",
};

const descriptions: Record<AuthMode, string> = {
  login: "Zadejte své přihlašovací údaje",
  register: "Vytvořte si účet pomocí přístupového kódu",
  "forgot-password": "Zadejte email pro zaslání odkazu na obnovu hesla",
};

export default function AuthPage() {
  const [mode, setMode] = useState<AuthMode>("login");

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center space-y-1">
          <h1 className="font-display text-6xl font-semibold tracking-[-0.05em] text-foreground">
            LastGO<span className="text-primary">.</span>
          </h1>
          <p className="text-sm uppercase tracking-[0.2em] text-muted-foreground">
            Partnerský portál
          </p>
        </div>

        <LGoCard variant="raised" padding="lg">
          <LGoCardHeader>
            <LGoCardTitle className="text-2xl">{titles[mode]}</LGoCardTitle>
            <LGoCardDescription>{descriptions[mode]}</LGoCardDescription>
          </LGoCardHeader>
          <LGoCardContent>
            {mode === "login" && (
              <LoginForm onForgotPassword={() => setMode("forgot-password")} />
            )}
            {mode === "register" && <RegisterForm onSuccess={() => setMode("login")} />}
            {mode === "forgot-password" && (
              <ForgotPasswordForm onSuccess={() => setMode("login")} />
            )}

            <div className="mt-6 text-center">
              {mode === "forgot-password" ? (
                <button
                  type="button"
                  onClick={() => setMode("login")}
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Zpět na přihlášení
                </button>
              ) : (
                <button
                  type="button"
                  onClick={() => setMode(mode === "login" ? "register" : "login")}
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  {mode === "login"
                    ? "Nemáte účet? Zaregistrujte se"
                    : "Již máte účet? Přihlaste se"}
                </button>
              )}
            </div>

            {mode !== "forgot-password" && (
              <p className="mt-3 text-center text-xs text-muted-foreground">
                <a
                  href={PARTNER_TERMS_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline hover:text-primary transition-colors"
                >
                  Podmínky pro partnery
                </a>
              </p>
            )}
          </LGoCardContent>
        </LGoCard>
      </div>
    </div>
  );
}
